<app-loader></app-loader>
<div class="initiate-booking-model">
    <div class="initiate-heading">
        <h5>Add Parker</h5>
        <img src="assets/images/new-close.svg" alt="Close" (click)="closeDialog(false)" />
    </div>
</div>
<div class="pakar-body-text" *ngIf="accountErrorMsg">
    <div class="information-icon">
        <h4 class="fill-error">{{accountErrorMsg}}</h4>
    </div>
</div>
<div class="register-body">
    <form [formGroup]="addParkerForm">
        <div class="register-input">
            <div class="search-input">
                <label for="email">Email </label>
                <div class="common-dropdown">
                    <div class="filter-parking">
                        <p-autoComplete formControlName="email" [readonly]="!!driverEmailIdReadOnly"
                            [suggestions]="filteredemail" [size]="30" [minLength]="1" [maxlength]="50"
                            placeholder="Enter Email" (completeMethod)="searchByContactField('email',$event)"
                            [dropdown]="false" (onSelect)="onEmailSelectionChange($event)"
                            (input)="onEmailInputChange($event)">
                            <ng-template let-filteredemail pTemplate="filteredemail">
                                <ul class="filter-search">
                                    <li class="location-label">
                                        <div class="locationbold">
                                            <h5>{{ (filteredemail.email ?filteredemail.email : filteredemail.message )
                                                }}</h5>
                                        </div>
                                    </li>
                                </ul>
                            </ng-template>
                        </p-autoComplete>

                    </div>
                    <div class="error-outer">
                        <div
                            *ngIf="addParkerForm.get('email')?.hasError('required')  && (addParkerForm.get('email')?.dirty || addParkerForm.get('email')?.touched)">
                            <div class="validation-error"> This field is required*</div>
                        </div>
                        <div
                            *ngIf="addParkerForm.get('email')?.hasError('pattern')  && (addParkerForm.get('email')?.dirty || addParkerForm.get('email')?.touched)">
                            <div class="validation-error"> Please enter a valid email*</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="search-input">
                <app-predictive-mobile-search-component [isLoading]="isLoading" [groupUserId]="groupUserId" [isEmailSearch]="isEmailSearch"

                    [filteredMobile]="filteredMobile" [resetNumberOnEmailChange]="resetNumber"
                    (selectMobileNumber)="onMobileSelectionChange($event)" (inputSearch)="onMobileTyping($event)"
                   (resetHandled)="onResetHandled()">
                </app-predictive-mobile-search-component>
            </div>

        </div>

        <div class="register-input">
            <div class="search-input">
                <label for="firstName">First Name <span class="custom-star">*</span></label>
                <input id="first-name" type="text" NoLeadingSpaceDirective pInputText placeholder="Enter First Name" maxlength="50"
                    formControlName="firstName" id="firstName" (input)="onFirstNameLastNameTyping()"/>
                <div class="error-outer" *ngIf="addParkerForm.get('firstName')?.dirty || addParkerForm.get('firstName')?.touched">

<div *ngIf="addParkerForm.get('firstName')?.hasError('required')" class="validation-error">
                        This field is required*
                    </div>

<div *ngIf="!addParkerForm.get('firstName')?.hasError('required') &&
                              addParkerForm.get('firstName')?.hasError('leadingSpace')" class="validation-error">
                        First Name cannot start with a space.*
                    </div>

<div *ngIf="!addParkerForm.get('firstName')?.hasError('required') &&
                              !addParkerForm.get('firstName')?.hasError('leadingSpace') &&
                              addParkerForm.get('firstName')?.hasError('pattern')" class="validation-error">
                        Please enter only characters*
                    </div>

<div *ngIf="!addParkerForm.get('firstName')?.hasError('required') &&
                              !addParkerForm.get('firstName')?.hasError('leadingSpace') &&
                              !addParkerForm.get('firstName')?.hasError('pattern') &&
                              addParkerForm.get('firstName')?.hasError('minlength')" class="validation-error">
                        Minimum 3 letters are required*
                    </div>

                </div>
            </div>
            <div class="search-input">
                <label for="lastName">Last Name<span *ngIf="requiredLastNameAsterisk" class="custom-star">*</span></label>
                <input id="lastName" type="text" NoLeadingSpaceDirective pInputText placeholder="Enter Last Name" maxlength="50"
                    formControlName="lastName" (input)="onFirstNameLastNameTyping()" />

                    <div class="error-outer" *ngIf="addParkerForm.get('lastName')?.dirty || addParkerForm.get('lastName')?.touched">

<div *ngIf="addParkerForm.get('lastName')?.hasError('required')" class="validation-error">
                        This field is required*
                    </div>

<div *ngIf="!addParkerForm.get('lastName')?.hasError('required') &&
                              addParkerForm.get('lastName')?.hasError('leadingSpace')" class="validation-error">
                        Last Name cannot start with a space.*
                    </div>

<div *ngIf="!addParkerForm.get('lastName')?.hasError('required') &&
                              !addParkerForm.get('lastName')?.hasError('leadingSpace') &&
                              addParkerForm.get('lastName')?.hasError('pattern')" class="validation-error">
                        Please enter only characters*
                    </div>

<div *ngIf="!addParkerForm.get('lastName')?.hasError('required') &&
                              !addParkerForm.get('lastName')?.hasError('leadingSpace') &&
                              !addParkerForm.get('lastName')?.hasError('pattern') &&
                              addParkerForm.get('lastName')?.hasError('minlength')" class="validation-error">
                        Minimum 3 letters are required*
                    </div>
                </div>
            </div>
        </div>
        <div class="save-btn">
            <p-button id="confirm-button" label="Confirm" (onClick)="addParker()"></p-button>
        </div>
    </form>
</div>
